import {
  GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING,
  GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_SUCCESS,
  GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getExternalProjectSubCategorytUrl } from "api/apiUrls";

export const getExternalProjectsSubCategoriesActions =
  (categoryId?: number, page?: number, pageSize?: number) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING,
        payload: true,
      });

      const response: any = await listItemsService(
        `${getExternalProjectSubCategorytUrl}/${categoryId}`,
        `page=${page}&pageSize=${pageSize}`
      );

      dispatch({
        type: GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_FAILURE,
        payload: err,
      });
    } finally {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING,
        payload: false,
      });
    }
  };
